import "./index.css";
import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import { App } from "./App";

render(
  <SWRConfig value={{ revalidateOnFocus: false, dedupingInterval: 10_000 }}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </SWRConfig>,
  document.getElementById("root")
);
